import { c as _c } from "react/compiler-runtime";
import { useExtendSessionId } from '@systemeio/util';
import { useDashboardUser } from './hooks/use-dashboard-user';
import { useUserStatus } from './hooks/use-user-status';
import { getAvatarUrl } from './utils/get-avatar-url';
const useUser = () => {
  const $ = _c(26);
  const {
    dashboardUser,
    dashboardMutate,
    isDisabled
  } = useDashboardUser();
  const user = !isDisabled ? dashboardUser : undefined;
  let t0;
  if ($[0] !== dashboardUser) {
    t0 = getAvatarUrl(dashboardUser);
    $[0] = dashboardUser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const avatarUrl = t0;
  const {
    isWsAdmin,
    checkAdminRoles,
    checkImpersonatorAdminRoles,
    isWorkspaceOwner,
    isAffiliate,
    isCustomer,
    isStudent,
    isWsAssistant,
    isRootAdmin,
    isWhiteLabelOwner,
    isSupportImpersonation,
    isSubAccountImpersonation,
    intlLocale,
    isRestrictedUser,
    isFreemium,
    isPaid
  } = useUserStatus(user);
  const workspaceId = user?.workspaceOwner ?? user?.id;
  const userContextKey = user ? `${user.id}_${user.impersonator?.id ?? ""}_${workspaceId}` : undefined;
  useExtendSessionId(userContextKey);
  const t1 = !dashboardUser;
  let t2;
  if ($[2] !== avatarUrl || $[3] !== checkAdminRoles || $[4] !== checkImpersonatorAdminRoles || $[5] !== dashboardMutate || $[6] !== dashboardUser || $[7] !== intlLocale || $[8] !== isAffiliate || $[9] !== isCustomer || $[10] !== isDisabled || $[11] !== isFreemium || $[12] !== isPaid || $[13] !== isRestrictedUser || $[14] !== isRootAdmin || $[15] !== isStudent || $[16] !== isSubAccountImpersonation || $[17] !== isSupportImpersonation || $[18] !== isWhiteLabelOwner || $[19] !== isWorkspaceOwner || $[20] !== isWsAdmin || $[21] !== isWsAssistant || $[22] !== t1 || $[23] !== user || $[24] !== userContextKey) {
    t2 = {
      user,
      dashboardUser,
      mutate: dashboardMutate,
      isCustomer,
      isAffiliate,
      isStudent,
      checkAdminRoles,
      checkImpersonatorAdminRoles,
      isWorkspaceOwner,
      isWsAdmin,
      isWsAssistant,
      isLoading: t1,
      isDisabled,
      isRootAdmin,
      isWhiteLabelOwner,
      isSubAccountImpersonation,
      isSupportImpersonation,
      intlLocale,
      isRestrictedUser,
      avatarUrl,
      isFreemium,
      isPaid,
      userContextKey
    };
    $[2] = avatarUrl;
    $[3] = checkAdminRoles;
    $[4] = checkImpersonatorAdminRoles;
    $[5] = dashboardMutate;
    $[6] = dashboardUser;
    $[7] = intlLocale;
    $[8] = isAffiliate;
    $[9] = isCustomer;
    $[10] = isDisabled;
    $[11] = isFreemium;
    $[12] = isPaid;
    $[13] = isRestrictedUser;
    $[14] = isRootAdmin;
    $[15] = isStudent;
    $[16] = isSubAccountImpersonation;
    $[17] = isSupportImpersonation;
    $[18] = isWhiteLabelOwner;
    $[19] = isWorkspaceOwner;
    $[20] = isWsAdmin;
    $[21] = isWsAssistant;
    $[22] = t1;
    $[23] = user;
    $[24] = userContextKey;
    $[25] = t2;
  } else {
    t2 = $[25];
  }
  return t2;
};
export default useUser;